import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Modal from 'components/Layout/Modal';
import { userRole } from 'utils/constants';
import { getDataFromLocalStorage } from 'utils/helpers';
import Dropdown from 'components/form/Dropdown';
import Button from 'components/form/Button';
import TextInput from 'components/form/TextInput';
import { UpdateSwitchUser } from 'store/slices';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';
import { useState } from 'react';

const UpdateSwitchUserModal = ({
  onHide,
  switchUserDetails,
  getUserSwitchRequestsData,
}) => {
  const dispatch = useDispatch();
  const loginUserRole = getDataFromLocalStorage('user_type');
  const filteredOptions = userRole?.filter((item) => item.id !== loginUserRole);
  const [btnLoading, setBtnLoading] = useState(false);

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const { update: updateAccess } =
    userDetails?.role_data?.find((item) => item?.permission_name === 'Requests')
      ?.sub_permission || {};

  const initialValues = {
    switch_to: switchUserDetails?.switch_to_enum || '',
    current_role: switchUserDetails?.current_role || '',
  };

  const validationSchema = Yup.object().shape({
    switch_to: Yup.string().required('Switch Role is required'),
  });

  const handleSave = async (values, { resetForm }) => {
    setBtnLoading(true);
    const payload = {
      request_id: switchUserDetails.request_id,
      user_type: values.switch_to,
    };
    try {
      const response = await dispatch(UpdateSwitchUser(payload));
      if (response?.status === 200) {
        onHide();
        resetForm();
        getUserSwitchRequestsData();
      }
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <Modal
      size="md"
      onHide={onHide}
      titleBesideClose="Edit Switch User"
      titleBesideCloseClassName="cps-15"
      isTitleBorder
      isTitleVerticalCenter
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSave}
      >
        {({ values, handleChange, handleSubmit, errors, touched }) => (
          <form>
            <div className="cps-20 cpe-20 cpt-20 cpb-20">
              <div className="cmb-10">
                <TextInput
                  label="Current Role"
                  placeholder="Enter Current Role"
                  id="current_role"
                  name="current_role"
                  value={values?.current_role}
                  readonly={true}
                />
              </div>

              <Dropdown
                label="Switch Role"
                id="switch_to"
                name="switch_to"
                placeholder="Select User Role"
                options={filteredOptions}
                optionKey="id"
                optionValue="title"
                value={values?.switch_to}
                onChange={handleChange}
                error={touched.switch_to && errors.switch_to}
              />

              <div className="d-flex justify-content-start gap-3 cpt-20">
                {updateAccess === '1' && (
                  <Button
                    text={loginUserRole === '0' ? 'Edit Request' : 'Submit'}
                    btnStyle="primary-dark"
                    className="cps-30 cpe-30 h-35"
                    btnLoading={btnLoading}
                    onClick={handleSubmit}
                    disabled={isEqual(values, initialValues) || btnLoading}
                  >
                    Update
                  </Button>
                )}
                <Button
                  text="Cancel"
                  btnStyle="light-outline"
                  className="cps-20 cpe-20 h-35"
                  onClick={onHide}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default UpdateSwitchUserModal;
